export const ERC20_ABI = [
  {
    inputs: [{ name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { name: 'to', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export const BRIDGE_ABI = [
  // lockTokens - amount, expectedAmountOut, bscRecipient (string)
  {
    inputs: [
      { name: 'amount', type: 'uint256' },
      { name: 'expectedAmountOut', type: 'uint256' },
      { name: 'bscRecipient', type: 'string' },
    ],
    name: 'lockTokens',
    outputs: [{ name: 'lockId', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  // cancelLock
  {
    inputs: [{ name: 'lockId', type: 'uint256' }],
    name: 'cancelLock',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  // getLock - returns multiple values, not a tuple
  {
    inputs: [{ name: 'lockId', type: 'uint256' }],
    name: 'getLock',
    outputs: [
      { name: 'user', type: 'address' },
      { name: 'amountIn', type: 'uint256' },
      { name: 'amountOut', type: 'uint256' },
      { name: 'bscRecipient', type: 'string' },
      { name: 'timestamp', type: 'uint256' },
      { name: 'status', type: 'uint8' },
      { name: 'externalTxHash', type: 'bytes32' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  // getUserLocks
  {
    inputs: [{ name: 'user', type: 'address' }],
    name: 'getUserLocks',
    outputs: [{ name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  // calculateFee
  {
    inputs: [{ name: 'amount', type: 'uint256' }],
    name: 'calculateFee',
    outputs: [
      { name: 'fee', type: 'uint256' },
      { name: 'amountOut', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  // feePercentage
  {
    inputs: [],
    name: 'feePercentage',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  // minLockAmount
  {
    inputs: [],
    name: 'minLockAmount',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  // maxLockAmount
  {
    inputs: [],
    name: 'maxLockAmount',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  // paused
  {
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  // getStats
  {
    inputs: [],
    name: 'getStats',
    outputs: [
      { name: '_lockCounter', type: 'uint256' },
      { name: '_pendingCount', type: 'uint256' },
      { name: '_approvedCount', type: 'uint256' },
      { name: '_totalActiveLocks', type: 'uint256' },
      { name: '_totalFeesCollected', type: 'uint256' },
      { name: '_totalProcessed', type: 'uint256' },
      { name: '_totalReleased', type: 'uint256' },
      { name: '_contractBalance', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  // Events
  {
    anonymous: false,
    inputs: [
      { indexed: true, name: 'lockId', type: 'uint256' },
      { indexed: true, name: 'user', type: 'address' },
      { indexed: false, name: 'amount', type: 'uint256' },
      { indexed: false, name: 'amountOut', type: 'uint256' },
      { indexed: false, name: 'bscRecipient', type: 'string' },
      { indexed: false, name: 'timestamp', type: 'uint256' },
    ],
    name: 'TokensLocked',
    type: 'event',
  },
] as const
